import {__} from '~/shared/src/utilities/messageCatalog';
import {SaveDataResult} from '~/shared/src/utilities/modules/data';

import {FINDER_DETAIL_SAVE_DATA} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import {
    getModifiedData,
    getModifiedDataRecursive,
    isDataModified
} from '~/frontend/src/utilities/dataUtils';
import {
    MsgParams,
    setMessage
} from '~/frontend/src/actions/intercom';
import dataSaveData from '~/frontend/src/actions/data/saveData';
import deferedInputValueUpdate from '~/frontend/src/actions/panel/common/deferedInputValueUpdate';

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {Schema} schema
 * @param {MsgParams | undefined} [successMsgParams=undefined]
 * @param {MsgParams | undefined} [nothingToSaveMsgParams=undefined]
 * @param {MsgParams | undefined} [errorMsgParams=undefined]
 *
 */
const saveData = ( panelKey : string, schema : Schema, successMsgParams : MsgParams | undefined = undefined, nothingToSaveMsgParams : MsgParams | undefined = undefined, errorMsgParams : MsgParams | undefined = undefined ) : Thunk<Promise<SaveDataResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<SaveDataResult | false> => {
    dispatch( {
        type: FINDER_DETAIL_SAVE_DATA,
        panelKey,
        schema
    } );

    await dispatch( deferedInputValueUpdate( panelKey, panelKey, schema ) );

    const requestUid = 'saveData';

    let retVal : SaveDataResult | false = false;

    // nothing to save
    if ( !isDataModified( panelKey, schema ) ) {
        if ( !nothingToSaveMsgParams ) {
            nothingToSaveMsgParams = [
                panelKey,
                'toast',
                'nothingToSave',
                {
                    severity: 'info',
                    summary : __( 'YN.base.finder.save.nothingToSave.title' ),
                    detail  : __( 'YN.base.finder.save.nothingToSave.text' )
                }
            ];
        }

        dispatch( setMessage( ...nothingToSaveMsgParams ) );
    }

    // save request running
    else if ( getState().xhr?.[ panelKey ]?.[ requestUid ] ) {
        dispatch( setMessage(
            panelKey,
            'toast',
            'saveRunning',
            {
                severity: 'info',
                summary : __( 'YN.base.finder.save.running.title' ),
                detail  : __( 'YN.base.finder.save.running.text' )
            }
        ) );
    }

    // save
    else {
        /*dispatch( setMessage(
            panelKey,
            'toast',
            'save',
            {
                severity: 'info',
                summary : __( 'YN.base.finder.save.saving.title' ),
                detail  : __( 'YN.base.finder.save.saving.text' )
            }
        ) );*/

        // revert deletion of (enum)properties for deleted references
        const modifiedData = getModifiedData( panelKey, schema );
        for ( const reference of modifiedData.references ) {
            if ( reference.isDeleted() ) {
                const statusId = reference.statusId;
                reference.reset().statusId = statusId;
            }
        }

        const result = await dispatch( dataSaveData(
            panelKey,
            panelKey,
            requestUid,
            schema
        ) );

        retVal = result;

        // save success
        if ( result.success ) {
            if ( !successMsgParams ) {
                successMsgParams = [
                    panelKey,
                    'toast',
                    'saveSuccess',
                    {
                        severity: 'success',
                        summary : __( 'YN.base.finder.save.saveSuccess.title' ),
                        detail  : __( 'YN.base.finder.save.saveSuccess.text' )
                    }
                ];
            }

            dispatch( setMessage( ...successMsgParams ) );
        }

        // save error
        else {
            if ( !errorMsgParams ) {
                errorMsgParams = [
                    panelKey,
                    'toast',
                    'saveError',
                    {
                        severity: 'error',
                        summary : __( 'YN.base.finder.save.saveError.title' ),
                        detail  : __( 'YN.base.finder.save.saveError.text' )
                    }
                ];
            }

            dispatch( setMessage( ...errorMsgParams ) );
        }
    }

    return retVal;
}
export type SaveData = typeof saveData;

export default saveData;
